export default __webpack_public_path__ + "static/1-76915ab212aeae6a557a3925289b4478.webp";